<template>
    <div>
        <b-row>
            <b-col md="6" class="my-1">
                <h3 class="text-themecolor">Orders</h3>
            </b-col>
            <b-col md="6" class="my-1">
                <div class="pull-right">
                    <b-button variant="themecolor" size="sm" @click="goTo('create')" class="mr-1">
                        <i class="fa fa-plus" aria-hidden="true"></i> {{$t('buttons.toevoegen')}}
                    </b-button>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="12">
                <div class="card">
                    <div class="card-body">
                        <!-- User Interface controls -->
                        <b-row>
                            <b-col md="12" class="my-1">
                                <b-form-group class="mb-0">
                                    <b-input-group>
                                        <b-form-input :value="filters.search" v-debounce="200" :placeholder="$t('datatables.zoeken')" ref='filters.search'/>
                                        <b-input-group-append>
                                            <b-input-group-append>
                                            <b-form-select v-model="filters.assignedUser" style="width:300px;">
                                                <option selected="selected" value="-1">{{$t('datatables.alle')}}</option>
                                                <option v-for="item in users" v-bind:key="item.id" :value="item.id">
                                                    {{ item.fullName }}
                                                </option>
                                            </b-form-select>
                                        </b-input-group-append>
                                            <b-form-select v-model="filters.administration">
                                                <option selected="selected" value="-1">{{$t('datatables.alle')}}</option>
                                                <option v-for="item in administrations" v-bind:key="item.id" :value="item.id">
                                                    {{ item.name }}
                                                </option>
                                            </b-form-select>
                                        </b-input-group-append>
                                        <b-input-group-append>
                                            <b-form-select v-model="filters.status">
                                                <option selected="selected" value="-1">{{$t('datatables.alle')}}</option>
                                                <option v-for="item in workOrderStatusses" v-bind:key="item.id" :value="item.key">
                                                    {{ item.value }}
                                                </option>
                                            </b-form-select>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <!-- User Interface controls -->
                        
                        <!-- Main table element -->
                        <b-row>
                            <b-col md="12">
                                <b-table show-empty 
                                         :small="true"
                                         :empty-text="getEmptyText(count)"
                                         stacked="md"
                                         class="table-hover"
                                         :items="workOrdersProvider"
                                         :fields="fields"
                                         :sort-by.sync="sortBy"
                                         :sort-desc.sync="sortDesc"
                                         :current-page="currentPage"
                                         :per-page="perPage"
                                         :filter="filters"
                                         @row-clicked="onRowClicked">
                                    <template v-slot:cell(number)="data">
                                        <div style="min-width:75px;">
                                            {{(data.item.CreatedAt.substr(0,4) + '-' +  data.item.Number)}}
                                       </div>
                                    </template>
                                    <template v-slot:cell(customerRelationName)="data">
                                        {{data.item.WorkOrderContactPersons.length > 0 ?
                                        data.item.WorkOrderContactPersons[0].ContactPerson.CustomerRelation.Name : ''}}
                                    </template>
                                    <template v-slot:cell(reference)="data">
                                        <div style="max-width:500px;word-wrap:break-word;">
                                           {{data.item.Reference}}
                                        </div>
                                    </template>
                                    <template v-slot:cell(assignedUsers)="data">
                                        {{ formatToInlineText(data.item.WorkOrderAssignedUsers) }}
                                    </template>
                                    <template v-slot:cell(administration)="data">
                                        {{ data.item.Administration.Name }}
                                    </template>
                                    <template v-slot:cell(status)="data">{{workOrderStatusses.filter(({key}) => key
                                        == data.item.Status)[0].value}}
                                    </template>
                                    <template v-slot:cell(actions)="row">
                                        <div class="pull-right">
                                            <b-button size="sm" variant="secondary" @click.stop="openNewWindow(row.item)">
                                                <i class="fa fa-external-link" aria-hidden="true"></i>
                                            </b-button>
                                        </div>          
                                    </template>
                                    <template v-slot:table-busy>
                                        <PreLoader/>
                                    </template>
                                </b-table>
                            </b-col>
                        </b-row>
                        <!-- Main table element -->
                        
                        <!-- Pagination controls -->
                        <b-row>
                            <b-col md="12" lg="1">
                                <b-form-group horizontal :label="$t('datatables.perpagina')">
                                    <b-form-select :options="pageOptions" v-model="perPage"/>
                                </b-form-group>
                            </b-col>
                            <b-col md="12" lg="11">
                                <b-pagination :total-rows="count" :per-page="perPage" v-model="currentPage"
                                              class="my-0 pull-right"/>
                            </b-col>
                        </b-row>
                        <!-- Pagination controls -->
                    </div>
                </div>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex';
import PreLoader from '@/components/root/Preloader';
import { getEmptyText } from '@/views/root/GetMessageTextHelper';
import Preferences from '@/providers/storage/preferences';

export default {
    name: `workorders-index`,
    components: {PreLoader},
    data() {
        return {
            currentPage: 1,
            perPage: 50,
            pageOptions: [50, 100, 200],
            count: -1,
            sortDesc: true,
            sortBy: "number",
            filters: {
                search: '',
                status: -1,
                assignedUser: -1,
                administration: -1
            },
            skippableFields: [
                'administrationId',
                'id',
                'lastAuditId',
                'createdBy',
                'lastAudit',
            ]
        };
    },
    computed: {
        ...mapGetters('comceptum', ['workOrderStatusses']),
        ...mapGetters('core',['administrations','users']),
        sortOptions() {
            return this.fields.filter(f => f.sortable).map(f => {
                return {text: f.label, value: f.key};
            });
        },
        filteredWorkOrders() {
            const vm= this;
            return vm.workOrders.filter(workOrder => vm.filterWorkOrder(vm,workOrder));
        },
        fields() {
            return[
                {key: 'number', label: this.$i18n.t('datatables.nummer'), sortable: true, sortExpression: (sortDirection) => `createdAt ${sortDirection}, number ${sortDirection}`},
                {key: 'customerRelationName', label: this.$i18n.t('datatables.relatie'), sortable: false},
                {key: 'reference', label: this.$i18n.t('datatables.referentie'), sortable: true},
                {key: 'assignedUsers', label: this.$i18n.t('datatables.toegewezenaan'), sortable: false},
                {key: 'administration', label: this.$i18n.t('datatables.administratie'), sortable: true, sortExpression: (sortDirection) => `Administration/Name ${sortDirection}`},
                {key: 'status', label: this.$i18n.t('datatables.status'), sortable: true},
                {key: 'actions', label: '', sortable: false }
            ]
        }
    },
    methods: {
        ...mapActions('comceptum', ['all']),
        workOrdersProvider(ctx, callback) {
                clearTimeout(this.$_timeout);
                this.$_timeout = setTimeout(() => {
                    var vm = this;

                    var filterQuery = vm.getFilterQuery(ctx.filter);      

                    var queryParameters = [
                            {key: '$top', value: ctx.perPage},
                            {key: '$skip', value: ctx.currentPage * ctx.perPage - ctx.perPage},
                            {key: '$filter', value: filterQuery},
                            {key: '$count', value: true},
                            {key: '$select', value: 'id,number,status,reference,createdAt'},
                            {key: '$expand', value: 'WorkOrderAssignedUsers($select=AssignedUser;$expand=AssignedUser($select=FirstName,LastName)),Administration($select=Name),WorkOrderContactPersons($select=ContactPerson;$expand=contactPerson($select=CustomerRelation;$expand=CustomerRelation($select=Name)))'}
                    ];

                    var orderByQuery = vm.getOrderByQuery(ctx.sortBy, ctx.sortDesc);
                    if(orderByQuery != null){
                        queryParameters.push({key: '$orderby', value: orderByQuery});
                    }

                    vm.all({
                        resource: 'workorders',
                        queryParameters: queryParameters,
                        cacheResult: false
                    }).then((data) => {
                        vm.count = data.metadata.count;

                        Preferences.Set('workorder_filters', ctx.filter);

                        callback(data.result);
                    }).catch(() => {
                        callback([]);
                    }); 
                }, 500)
        },
        formatToInlineText(workOrderAssignedUsers) {
            var inlineText = '';

            if (workOrderAssignedUsers.length == 0) {
                return inlineText;
            }

            for (let i = 0; i < workOrderAssignedUsers.length; i++) {
                var user = workOrderAssignedUsers[i].AssignedUser;
                inlineText += user.FirstName + ' ' + user.LastName + ', ';
            }

            inlineText = inlineText.slice(0, -2);
            return inlineText;
        },
        getFilterQuery: function(filters) {
            var query = '1 eq 1';

            if(filters.search !== '' && filters.search != null){
                query += ` and (contains(reference, '${filters.search}') or 
                    contains(concat(concat(cast(year(CreatedAt), 'Edm.String'), '-'), cast(Number, 'Edm.String')), '${filters.search}') or        
                    contains(Administration/Name, '${filters.search}') or
                    WorkOrderContactPersons/any(x: contains(x/ContactPerson/FirstName, '${filters.search}') or contains(x/ContactPerson/LastName, '${filters.search}') or contains(x/ContactPerson/CustomerRelation/Name, '${filters.search}')) or
                    WorkOrderAssignedUsers/any(x: contains(x/AssignedUser/FirstName, '${filters.search}') or contains(x/AssignedUser/LastName, '${filters.search}'))`
                query += `)`
            }

            if(filters.assignedUser != -1) {
                query += " and WorkOrderAssignedUsers/any(x: x/AssignedUserId eq " + filters.assignedUser + ")";
            }

            if (filters.status != -1) {
                query += " and status eq Be.Comceptum.Domain.WorkOrderStatus'" + filters.status + "'";
            }
            else if(filters.search == '' || filters.search == null) {
                query += " and status ne Be.Comceptum.Domain.WorkOrderStatus'" + 6 + "'";
            }

            if (filters.administration != -1) {
                query += " and administrationId eq " + filters.administration;
            }

            return query;
        },
        getOrderByQuery: function(sortBy, sortDesc) {
            if(!sortBy && !sortDesc) return null;

            var sortDirection = sortDesc ? 'desc' : 'asc';

            var field = this.fields.find((x) => x.key === sortBy);
            if(field.sortExpression){
                return field.sortExpression(sortDirection);
            }

            return `${sortBy} ${sortDirection}`;
        },
        onRowClicked(item) {
            this.$router.push({name: `workorders:detail`, params: {workOrderId: item.Id}});
        },
        openNewWindow(item) {
            let routeData = this.$router.resolve({name: `workorders:detail`, params: {workOrderId: item.Id}});
            window.open(routeData.href,'_blank');
        },
        goTo(name) {
            this.$router.push({name: `workorders:${name}`});
        },
        getEmptyText
    },
    watch: {
        filters: {
            deep: true,
            handler: function(newValue) {}// eslint-disable-line
        }
    },
    created() {
        this.$_timeout = null;
        var vm = this;
        vm.$store.dispatch('core/all', {
            resource: 'administrations'
        });
        vm.$store.dispatch('core/all', {
            resource: 'users'
        });

        var filters = Preferences.Get('workorder_filters');
        if(filters)
            vm.filters = filters;
    },
    beforeDestroy() {
      clearTimeout(this.$_timeout)
  },    
};
</script>